import React, { useState, useEffect } from 'react';
import mydoge from '../images/mydoge.webp';
import coinbase from '../images/coinbasewallet.png';
import exodus from '../images/exodus.png';
import trust from '../images/trustwallet.png';
import safepal from '../images/safepal.png';
import atomic from '../images/atomic.jpeg';

const WalletCarousel = () => {
  const [currentPage, setCurrentPage] = useState(0);

  // All wallet logos
  const wallets = [
    { src: mydoge, alt: 'MyDoge' },
    { src: coinbase, alt: 'Coinbase Wallet' },
    { src: exodus, alt: 'Exodus' },
    { src: trust, alt: 'Trust Wallet' },
    { src: atomic, alt: 'Atomic Wallet' },
    { src: safepal, alt: 'SafePal' },
  ];

  // Show 3 wallets per page
  const walletsPerPage = 3;
  const totalPages = Math.ceil(wallets.length / walletsPerPage);

  // Auto-advance every 4 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentPage((prev) => (prev + 1) % totalPages);
    }, 4000);

    return () => clearInterval(timer);
  }, [totalPages]);

  // Get current page wallets
  const startIndex = currentPage * walletsPerPage;
  const currentWallets = wallets.slice(startIndex, startIndex + walletsPerPage);

  // Responsive scale factor based on screen size
  const isIPad = window.innerWidth >= 768 && window.innerWidth <= 1024;
  const isLandscape = window.innerHeight < 450 && window.innerWidth > window.innerHeight;

  // Dynamic scale: smaller screens get smaller scale in landscape
  const getScaleFactor = () => {
    if (isIPad) return 1.25;
    if (isLandscape) {
      // Scale from 0.6 (very small) to 0.85 (larger phones) based on viewport width
      const minScale = 0.6;
      const maxScale = 0.85;
      const minWidth = 568; // iPhone SE landscape
      const maxWidth = 932; // iPhone Pro Max landscape
      const width = window.innerWidth;
      const scale = minScale + ((width - minWidth) / (maxWidth - minWidth)) * (maxScale - minScale);
      return Math.max(minScale, Math.min(maxScale, scale));
    }
    return 1;
  };

  const scaleFactor = getScaleFactor();

  return (
    <div style={{
      width: '100%',
      textAlign: 'center',
      padding: '5px 0'
    }}>
      {/* Title */}
      <div style={{
        fontSize: `${13 * scaleFactor}px`,
        fontWeight: '600',
        color: '#374151',
        marginBottom: `${10 * scaleFactor}px`,
        letterSpacing: '0.5px'
      }}>
        Supported Wallets
      </div>

      {/* Carousel Container */}
      <div style={{
        position: 'relative',
        height: `${70 * scaleFactor}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: `${12 * scaleFactor}px`,
        padding: '0 10px'
      }}>
        {currentWallets.map((wallet, index) => (
          <div
            key={`${currentPage}-${index}`}
            style={{
              width: `${80 * scaleFactor}px`,
              height: `${65 * scaleFactor}px`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              borderRadius: `${10 * scaleFactor}px`,
              padding: `${8 * scaleFactor}px`,
              boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
              animation: 'fadeIn 0.8s ease-in-out',
              transition: 'transform 0.2s ease'
            }}
          >
            <img
              src={wallet.src}
              alt={wallet.alt}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain'
              }}
            />
          </div>
        ))}
      </div>

      {/* Dots Indicator */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: `${6 * scaleFactor}px`,
        marginTop: `${12 * scaleFactor}px`
      }}>
        {Array.from({ length: totalPages }).map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index)}
            style={{
              width: `${7 * scaleFactor}px`,
              height: `${7 * scaleFactor}px`,
              borderRadius: '50%',
              border: 'none',
              backgroundColor: currentPage === index ? '#1E3A8A' : '#D1D5DB',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              padding: 0
            }}
            aria-label={`Go to page ${index + 1}`}
          />
        ))}
      </div>

      {/* CSS Animation */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default WalletCarousel;
